/**
 * It's suggested to configure the RESTful endpoints in this file
 * so that there is only one source of truth, future update of endpoints
 * could be done from here without refactoring on multiple places throughout the app
 */
export const ApiLibrary = {
  OAUTH_TOKEN: 'uaa/oauth/token',
  OAUTH_REVOKE_TOKEN: 'uaa/oauth/revoke/token',
  NOTIFICATION_PONG_REQUEST: 'api/pong',
  ADD_MSAL_TOKEN: 'jwt/token/aad',
  ADD_GOOGLE_TOKEN: 'jwt/token/google',
  V2: {
    BIZ_BASIC_ROUTE: 'v2/business/team/',
    BIZ_ACCT_CREATE: 'v2/biz/account/create',
    BIZ_ACCT_FORGOT_PWD: 'v2/biz/account/forgot/password',
    BIZ_ACCT_VERIFY_OTP: 'v2/biz/account/verify/otp',
    BIZ_ACCT_RESEND_OTP: 'v2/biz/account/resendotp',
    BIZ_ACCT_RESET_PWD: 'v2/biz/account/reset/password',
    BIZ_ACCT_UPDATE_PWD: 'v2/biz/account/update/password',
    BIZ_USR_ACCT_ACTIVE_BIZS_UUID: 'v2/biz/account/active/business',
    BIZ_USR_ACCT_ACTIVE_BIZS: 'v2/business/user/account/active/businesses',
    BIZ_USR_ACCT_VALIDATE_EMAIL: 'v2/business/user/account/validate/email',
    H360_BIZ_REQ_CREATE: 'v2/h360/businessreq/create',
    BIZ_ACCT: 'v2/biz/account',
    HOME_BIZ: 'v2/home/business',
    TEAM_LIST: 'v2/business/team/list',
    VERIFY_TEAM_NAME: 'v2/business/team/verify/',
    CREATE_BIZ_TEAM: 'v2/business/team/create',
    UPDATE_BIZ_TEAM: 'v2/business/team/update/',
    ACCOUNTS_LIST: 'v2/business/user/account/list',
    BIZ_ACCOUNT_MEDIA: 'media?key=',

    BIZ_TEAM_DETAIL: 'v2/business/team/',
    BIZ_GET_TEAM_MEMBERS: 'v2/business/user/account/team/list/',
    BIZ_USERS_ACCOUNT_LIST: 'v2/business/user/account/list/0/0',
    GET_USER_ACCOUNT: 'v2/business/user/account/list',
    GET_USER_ACCOUNT_DETAILS: 'v2/business/user/account',
    SEND_INVITE: 'v2/business/user/account/invite',
    UPDATE_USER_ACCOUNT_DETAILS: 'v2/business/user/account/update',
    USER_ACCOUNT_APP_LIST: 'v2/business/user/account/service/access/list',
    HOME_CALENDAR: 'v2/service/dashboard/calendar',
    HOME_FIELDS: 'v2/home/fields/v1',
    USER_ACCOUNT_ACTIVITY_LIST: 'v2/activity/list/',
    VERIFY_USER_ACCOUNT_INVITE_UPLOAD: 'v2/business/user/account/invite',
    // USER_ACCOUNT_ACTIVITY_LIST: 'v2/activity/list/1/20',

    // ========================== report apis end points ===============================
    GET_REPORTS_LIST: 'v2/report/list',
    GET_REPORT_DETAIL_INFO: 'v2/report',
    GET_REPORT_DETAIL_LIST: 'v2/report/request/list',
    GET_FORM_FIELD: 'v2/home/fields/v1',
    CREATE_NEW_REPORT: 'v2/report/request/create',
    // =================================================================================
    // USER_ACCOUNT_ACTIVITY_LIST: 'v2/activity/list/1/20',
    FLOWS_LIST: 'v2/data/flow/list/1/15/*',
    FLOWS_PROCESSOR_LIST: 'v2/data/flow/processor/list/1/15',
    ASSERT_UPLOAD: 'v2/asset/library/temp/upload',
    LOOKUP_API: 'v2/home/lookup/v2',
    COMMENTS_LIST: 'v2/comment/list',
    COMMENT_UPDATE: 'v2/comment/update',
    COMMENT_SAVE: 'v2/comment/post',
    DELETE_CMNT: 'v2/transaction/comment',
    ASSERT_LIST: 'v2/asset/list',

    // ================================ transaction apis =================================
    TR_FILTER_LIST: 'v2/service/filters',
    TR_SAVED_FILTER_LIST: 'v2/saved/filter/list',
    TR_OWNER_LIST: 'v2/service/access/enabled/list',
    TR_LIST: 'v2/transaction/list',
    TR_LOCATION: 'v2/transaction',
    TR_CREATE_TASK: 'v2/task/create',
    TR_GET_TASK_LIST: 'v2/task/list',
    TR_ADD_COMMENT: 'v2/comment/post',
    TR_GET_COMMENT_LIST: 'v2/comment/list/1/10?refId=',
    TR_DELETE_COMMENT: 'v2/comment/delete/',
    TR_LOOKUP_LIST: 'v2/home/lookup/v2/',
    TR_ASSIGN: 'v2/transaction/assign',
    // ===================================================================================
    // ===================== APPS SETTINGS ==================================
    BIZ_GET_PERSPECTIVE_LIST: 'v2/perspective/list',
    GET_ENABLE_USER_ACCOUNT_LIST: 'v2/service/access/enabled/list',
    ADD_USER: 'v2/perspective/access/add',
    REMOVE_USER_PERSPECTIVE: 'v2/perspective/access/list',
    REMOVE_USER: 'v2/perspective/access/remove',
    UPDATE_MY_TRANSACTIONS_NOTIFICATIONS: 'v2/business/user/account',
    APPS_ACTIVITY_LIST: 'v2/activity/list',
    TXN_CREATE: 'v2/transaction/create',

    // =========== USER NOTIFICATIONS LIST ================
    USER_NOTIFICATIONS_LIST: 'v2/user/notification/list',
    USER_NOTIFICATION_UPDATE: 'v2/user/notification/update',

    // ========================= Change Business ===================================
    USER_BUSINESS_ACCOUNT_LIST: 'v2/business/user/account/list',
    BUSINESS_LIST: 'v2/business/list',
    TXN_DETAILS: 'v2/transaction',
    SUB_FROM_DATA: 'v2/subform/data',
    TXN_UPDATE: 'v2/transaction/update',
    TXN_ACTIVITY_LIST: 'v2/activity/list',
    TXN_ASSERT_LIST: 'v2/asset/list',
    ASSERT_DELTE: 'v2/asset/delete',
    ASSERT_CREATE: 'v2/transaction/asset/create',
    ASSERT_UPDATE: 'v2/asset/update',
    SUBFORM_CREATE: 'v2/subform/data/create',
    SUBFORM_UPDATE: 'v2/subform/data/update',
    LOOKUP_DATA: 'v2/home/related/list',
    TABLE_ROW_LIST: 'v2/table/row/list',
    TXN_LIST: 'v2/transaction/list',
    TRANSACTION_ACTION_EXECUTE: 'v2/transaction/action/execute',
    // ========================= Chart Data ===================================
    CHART_DATA: 'v2/service/dashboard/execute/',
    CHART_DATA_FIELDS: 'v2/service/dashboard/fields/execute/',
    DASHBOARD_LIST: 'v2/service/dashboard/list',
    TABLE_DASHBOARD_TXN_LIST: 'v2/service/dashboard/v1/execute/table/dashboard',
    DASHBOARD_BY_ID: 'v2/service/dashboard',
    SUB_FORM_PREVIEW: 'v2/subform/data/preview/fields',
    APPS_ACTION_COUNT: 'v2/transaction/actions/count',
    FAVOURITE_DASHBOARDS: 'v2/business/user/account/update',

    USER_ACCOUNT_IMAGE_UPLOAD: 'v2/business/user/account/logo/upload',
    TRANACTION_NOTIFICATION_ACTIVITY_MODAL: 'v2/activity',
    TRANACTION_NOTIFICATION_MODAL_ASSET_MODAL: 'v2/asset',
    TRANACTION_NOTIFICATION_MODAL_COMMENT_MODAL: 'v2/comment',

    // =========================== Table Related ===============================
    TABLE_ROWS_DATA: 'v2/table/row/list',
    ADD_TABLE_ROW: 'v2/table/row/create',
    UPDATE_TABLE_ROW: 'v2/table/row/update',
    DELETE_TABLE_ROW: 'v2/table/row/delete',
    ROW_ORDER_UPDATE: 'v2/table/row/update/roworder',
    BULK_ROWS_DELETE: 'v2/table/row/bulk/delete',
    BULK_ROWS_ADD: 'v2/table/row/bulk/insert',
    BULK_ROWS_UPDATE: 'v2/table/row/bulk/update',
  
    // =========================== TASKS ===============================
    TASKS_LIST: 'v2/task/list',
    TASK_UPDATE: 'v2/task/update',
    TASK_CREATE: 'v2/task/create',
    HOME_SERVICE_DATA: 'v2/home/service',
    TXN_DATA_IMPORT_CSV_CREATE: 'v2/data/import/create',
    TXN_DATA_IMPORT_CSV_LIST: 'v2/data/import/list',
    TXN_DATA_IMPORT_FILE_UPLOAD: 'v2/data/import/file/upload',
    TXN_DATA_IMPORT_PUBLISH: 'v2/data/import/publish/',
    TXN_DATA_IMPORT_RUN: 'v2/data/import/run/',
    TXN_DATA_IMPORT_EXECUTE: 'v2/data/flow/execution',
    TXN_DATA_IMPORT_ERROR_LOGS: 'v2/data/flow/view/log',
    TXN_DATA_IMPORT_DETAILS_ID: 'v2/data/import',
    DATA_DECRYPT: 'v2/data/decrypt',
    TABLE_ASSERT_UPLOAD: 'v2/transaction/asset/create',
    TABLE_ROW_ASSERT_LIST: 'v2/asset/list/fetch',
    TABLE_ROW_COMMENTS_LIST: 'v2/comment/list/fetch',
    TABLE_ROW_UPDATE_COMMENT_CREATE: 'v2/table/row/comment/post',
    TABLE_ROW_UPDATE_ASSERT_CREATE: 'v2/table/row/asset/create',

    // =========================== Google Token ===============================
    GOOGLE_AUTH_TOKEN: 'v2/oauth/google',

    // =========================== Public Form ===============================
    PUBLIC_FORM_DATA: 'v2/public/form/url/fetch',
  },
};
